module.exports = __webpack_public_path__ + "img/do.526509b9.svg";